var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Container',[_c('div',{class:_vm.$style.container},[_c('h1',{class:_vm.$style.title},[_vm._v("404")]),_c('p',{class:_vm.$style.subtitle},[_vm._v(" The page you are looking for cannot be found ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }